/*********************************************************************************************
 * Sets up the cart form submission handler.
 */
function mmSetupProductForm() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
	if (!forms) return;

	forms.forEach((form) => {
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const formData = new FormData(form);

			fetch("/cart/add.js", {
				method: "POST",
				body: formData,
			})
            .then((response) => response.json())
            .then((data) => {
                window.location.href = "/checkout";
            })
            .catch((error) => {
                console.error("Erreur:", error);
            });
		});
	});
}

/*********************************************************************************************
 * Variant Selector
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange.bind(this));
	}

	onVariantChange() {
		this.updateOptions();
		this.updateVariantId();
		this.updateURL();
		this.updateVariantData();
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('input[type="radio"]:checked'),
			(input) => input.value
		);
	}

	updateVariantId() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (selectedVariant) {
			const input = document.querySelector('input[name="id"]');
			if (input) {
				input.value = selectedVariant.id;
			}
		}
	}

	updateURL() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (selectedVariant) {
			const url = new URL(window.location);
			url.searchParams.set('variant', selectedVariant.id);
			window.history.replaceState({}, '', url);
		}
	}

	getVariantData() {
		const json = this.querySelector('script[type="application/json"]');
		return json ? JSON.parse(json.textContent) : [];
	}

	async updateVariantData() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (!selectedVariant) return;

		const sectionId = this.dataset.section;
		const url = this.dataset.url;

		if (!sectionId || !url) return;

		try {
			const response = await fetch(`${url}?variant=${selectedVariant.id}&section_id=${sectionId}`);
			const html = await response.text();
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Mettre à jour tous les éléments avec data-product-reload
			const elementsToUpdate = document.querySelectorAll('[data-product-reload]');
			elementsToUpdate.forEach((element) => {
				const newElement = doc.querySelector(`[data-product-reload="${element.dataset.productReload}"]`);
				if (newElement) {
					element.innerHTML = newElement.innerHTML;
				}
			});
		} catch (error) {
			console.error('Erreur lors de la mise à jour des données variant:', error);
		}
	}
}

customElements.define('variant-selector', VariantSelector);

document.addEventListener("DOMContentLoaded", (event) => {
	mmSetupProductForm();
});